import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { CardTransactionComponent } from "./cardtransaction.component";
import { CardTransactionService } from "./cardtransaction.service";
import { CalendarModule } from 'primeng/components/calendar/calendar'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CO2CountsComponent } from "./co2counts.component";
import { CardTransactionNewComponent } from "./cardtransactionnew.component";
import { CO2CountsNewComponent } from "./co2countsnew.component";
import { AccountCO2CountsComponent } from "./accountco2counts.component";
import { AccountCardTransactionComponent } from "./accountcardtransaction.component"
@NgModule({
    imports: [
        SharedModule,
        BrowserAnimationsModule,
        CalendarModule,
        RouterModule.forChild([
          //{ path: 'cardtransaction', component: CardTransactionComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'cardtransaction', component: CardTransactionNewComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'cardtransaction2', component: AccountCardTransactionComponent, canActivate: [AuthGuard, AccountGuard] },
          //{ path: 'co2counts', component: CO2CountsComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'co2counts', component: CO2CountsNewComponent, canActivate: [AuthGuard, AccountGuard] },
          { path: 'co2countsNew', component: AccountCO2CountsComponent, canActivate: [AuthGuard, AccountGuard] },
        ])
    ],
    exports: [

    ],
    declarations: [
      CardTransactionComponent,
      CardTransactionNewComponent,
      CO2CountsComponent,
      CO2CountsNewComponent,
      AccountCardTransactionComponent,
      AccountCO2CountsComponent
    ],
    providers: [
        CardTransactionService
    ]
})
export class CardTransactionModule {

}



// WEBPACK FOOTER //
// ./src/app/cardtransaction/cardtransaction.module.ts